import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function CloseInCircleIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="8" cy="8" r="8" fill={color}/>
            <path d="M11.5554 4.44434L4.44434 11.5554" stroke="#FCFAF8" strokeWidth="1.6" strokeLinecap="round"/>
            <path d="M4.44455 4.44434L11.5557 11.5554" stroke="#FCFAF8" strokeWidth="1.6" strokeLinecap="round"/>
        </svg>
    );
}

export default CloseInCircleIcon;
